import React from 'react';
import Flex from '../layout/flex';
import DesktopNavBar from './desktop-nav-bar';
import MobileNavBar from './mobile-nav-bar';

interface NavBarProperties {
  isDesktop: boolean;
}

function NavBar({ isDesktop }: NavBarProperties) {
  return (
    <Flex
      direction="row"
      justify="center"
      items="center"
      gap="gap-5"
      md="md:items-end"
      className="self-stretch"
    >
      {!isDesktop && <MobileNavBar />}
      {isDesktop && <DesktopNavBar />}
    </Flex>
  );
}

export default NavBar;
